const pluginName = 'paginatedLiveFilter';
const selectors = {
  searchInput: '[data-js-paginated-live-filter-search-input]',
  searchForm: '[data-js-paginated-live-filter-search-form]',
  listItems: '[data-js-paginated-live-filter-list-item]',
  paginationPrevious: '[data-js-paginated-live-filter-pagination-previous]',
  paginationNext: '[data-js-paginated-live-filter-pagination-next]',
  resultCount: '[data-js-paginated-live-filter-result-count]',
};
const classes = {
  hidden: 'd-none',
  disabled: 'disabled',
};
const defaults = {
  pageSize: 8,
};

const getElements = ($element) => ({
  $element,
  $searchInput: $element.find(selectors.searchInput),
  $searchForm: $element.find(selectors.searchForm),
  $listItems: $element.find(selectors.listItems),
  $paginationPrevious: $element.find(selectors.paginationPrevious),
  $paginationNext: $element.find(selectors.paginationNext),
  $resultCount: $element.find(selectors.resultCount),
});

/**
 * Builds a results set based on the users search input, then paginates it
 */
const showFilteredResults = (data) => {
  // we set to lowercase just in case user uses capitals or search terms contain capitals
  const searchString = data.elements.$searchInput
    .val()
    .trim()
    .toLowerCase();

  // if there is no search string, set results to the entire list set
  const $results = searchString
    ? data.elements.$listItems.filter((index, listItem) => {
      const $listItem = $(listItem);
      const searchTerm = ($listItem.attr('data-live-filter-search') || '').toLowerCase();

      return searchTerm.includes(searchString);
    })
    : data.elements.$listItems;

  const resultCount = $results.length;
  const pageStart = data.currentPage * data.settings.pageSize;
  let pageEnd = data.currentPage * data.settings.pageSize + data.settings.pageSize;

  if (pageEnd > resultCount) {
    pageEnd = resultCount;
  }

  const $page = $results.slice(pageStart, pageEnd);

  // show all results that are in the current page
  $page.each((index, result) => {
    $(result).removeClass(classes.hidden);
  });

  // hide all results that are not in the current page
  data.elements.$listItems
    .not($page)
    .each((index, result) => {
      $(result).addClass(classes.hidden);
    });

  if (resultCount) {
    const newResultCountString = data.elements.$resultCount.attr('data-results-string')
      .replace('%start%', pageStart + 1)
      .replace('%end%', pageEnd)
      .replace('%total%', resultCount);

    data.elements.$resultCount.text(newResultCountString);
  } else {
    const newResultCountString = data.elements.$resultCount.attr('data-no-results-string')
      .replace('%total%', data.elements.$listItems.length);

    data.elements.$resultCount.text(newResultCountString);
  }

  if (!data.currentPage) {
    data.elements.$paginationPrevious.addClass(classes.disabled);
  } else {
    data.elements.$paginationPrevious.removeClass(classes.disabled);
  }

  if (data.currentPage * data.settings.pageSize + data.settings.pageSize > resultCount) {
    data.elements.$paginationNext.addClass(classes.disabled);
  } else {
    data.elements.$paginationNext.removeClass(classes.disabled);
  }
};

const updatePage = (data, page) => {
  $.extend(true, data, {
    currentPage: page,
  });

  data.elements.$element.data(pluginName, data);
};

const initialize = (element, options) => {
  const $element = $(element);

  if ($element.data(pluginName)) {
    return;
  }

  const settings = $.extend(true, {}, $.fn[pluginName].defaults, options);

  const elements = getElements($element);

  const data = {
    elements,
    settings,
    currentPage: 0,
  };

  // we don't want anything to happen if the user hits enter
  data.elements.$searchForm.on('submit', (event) => {
    event.preventDefault();
  });

  data.elements.$searchInput.on('keyup', () => {
    // if the user is on page 5 and searches again, go back to page 0
    updatePage(data, 0);
    showFilteredResults(data);
  });

  data.elements.$paginationPrevious.on('click', () => {
    if (data.currentPage === 0) {
      return;
    }

    updatePage(data, data.currentPage - 1);
    showFilteredResults(data);
  });

  data.elements.$paginationNext.on('click', () => {
    updatePage(data, data.currentPage + 1);
    showFilteredResults(data);
  });

  showFilteredResults(data);

  $element.data(pluginName, data);
};

const plugin = function Plugin(options) {
  return this.each((index, element) => initialize(element, options));
};

plugin.defaults = defaults;

$(() => {
  if (plugin in $.fn) {
    return;
  }

  $.extend($.fn, {
    [pluginName]: plugin,
  });

  $(() => {
    $('[data-js-paginated-live-filter]')[pluginName]();
  });
});
